import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

// Components
import {
  Element,
  Box,
  FlipContent,
  useFlip,
  TogglePosition,
  FlipDirection
} from '@americanexpress/aqx-components';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { Front } from './components/Front';
import { FrontForG157 } from './components/FrontForG157';
import { Back } from './components/Back';
import { SectionTitle } from '../SectionTitle';
import G157Carousel from 'src/universal/components/Experiments/G157/BusinessValueTilesCarousel';

// Selectors
import { getSummitBenefitImpression, getShouldRender } from './redux';
import { getSummitData } from '../../redux';
import { isG157Variant } from 'src/universal/components/Experiments/G157/redux';

// Utils
import { sendDTMCustomEvent } from 'service_modules/models/dtm-tagging';
import { useBreakpoint } from '@americanexpress/aqx-components';

// Styles
import styles from './__styles__/index.scss?modules';

const Tile = ({
  content,
  flipDirection = FlipDirection.Horizontal,
  isG157,
  index
}) => {
  const { isFlipped, setIsFlipped, rotation, setRotation } = useFlip();
  const { dtm } = content;
  const handleFlip = () => {
    setIsFlipped(!isFlipped);
    setRotation(r => r + 180);

    if (isFlipped) {
      const updatedDtm = {
        ...dtm,
        eventAsset: `${dtm.eventAsset}-back`
      };
      sendDTMCustomEvent(updatedDtm);
    } else {
      sendDTMCustomEvent(dtm);
    }
  };

  const togglePos = isG157 ? TogglePosition.TopRight : TogglePosition.BottomRight;

  const frontTile = isG157 ? (
    <FrontForG157 content={content} index={index} />
  ) : (
    <Front content={content} />
  );

  return (
    <FlipContent
      isFlipped={isFlipped}
      handleFlip={handleFlip}
      rotation={rotation}
      togglePosition={togglePos}
      ariaLabelFront={content.frontAriaLabel}
      ariaLabelBack={content.backAriaLabel}
      cardStyles={{ back: { display: 'flex' }, front: { display: 'flex' } }}
      frontClassName={styles.container}
      backClassName={styles.container}
      flipDirection={flipDirection}
    >
      {frontTile}
      <Back content={content} />
    </FlipContent>
  );
};

const Tiles = ({ data, shouldRender, dtmImpressionEvent, isG157 }) => {
  if (!shouldRender) {
    return null;
  }

  const { sm } = useBreakpoint();
  const { header, content } = data;
  const largeTile = content[0];
  const smallTiles = content.slice(1);
  const itemHeaderList = [];

  if (sm && isG157) {
    const slideList = content.map((item, i) => {
      itemHeaderList.push(item.header);
      return (
        <div className={styles.innerBox} key={i}>
          <Tile content={item} isG157={true} index={i} />
        </div>
      );
    });

    return (
      <div
        className={clsx(styles.outerBox, styles.bottomTiles, {
          [styles.isG157]: true
        })}
      >
        <G157Carousel
          slideList={slideList}
          header={header}
          needHeaderBox={false}
          originKey="benefitsTiles"
          itemHeaderList={itemHeaderList}
        />
      </div>
    );
  }

  return (
    <React.Fragment>
      <Box className={styles.outerBox}>
        <LazyScrollMetricTracker
          startTrackingAfterPznArrival={true}
          scrollDtm={dtmImpressionEvent}
        />
        <SectionTitle text={header} />
        <Element className={styles.topTile}>
          <Tile content={largeTile} flipDirection={FlipDirection.Vertical} />
        </Element>
        <Element className={styles.bottomTiles}>
          {smallTiles.map((smallTile, i) => (
            <Element className={styles.innerBox} key={i}>
              <Tile content={smallTile} />
            </Element>
          ))}
        </Element>
      </Box>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  shouldRender: getShouldRender(state),
  data: getSummitData(state),
  dtmImpressionEvent: getSummitBenefitImpression(state),
  isG157: isG157Variant(state)
});

export const FeaturedBenefitsTiles = connect(mapStateToProps)(Tiles);
